// extracted by mini-css-extract-plugin
var _1 = "AttachTasksModal-moduleemptyState__D4G2U";
var _2 = "AttachTasksModal-moduletable__OC6qf TableComponent-moduleTable__mhqNq";
export { _1 as "emptyState", _2 as "table" }
